module.exports = __webpack_public_path__ + "img/icon_Infrastructure.6fb0ccb8.svg";